import React from 'react'
import Header from "../../Component/termsandcon/termsheader/Termsheader"
import Section from "../../Component/termsandcon/termsection/Termsection"
import Footer from "../../Component/termsandcon/termsfooter/Termsfooter"

 function TermsAndCondition() {
    return (
        <div>
            <Header />
            <Section />
            <Footer />
        </div>
    )
}

export default TermsAndCondition;
